import React, { useCallback, useEffect, useState } from "react";
import VendorPortalLayout from "../components/VendorPortalLayout";
import { vendorPortalApi } from "../api/vendorPortalApi";
import { useVendorPortalSession } from "../session/vendorPortalSession";

var VendorPortalStockPage = function () {
  var session = useVendorPortalSession();
  var _rows = useState([]);
  var rows = _rows[0], setRows = _rows[1];
  var _e = useState("");
  var error = _e[0], setError = _e[1];
  var _s = useState("");
  var success = _s[0], setSuccess = _s[1];

  var load = useCallback(function () {
    if (!session.eventId || !session.stallId) return;
    vendorPortalApi.listStock({
      event_id: session.eventId,
      stall_id: session.stallId
    })
      .then(function (p) { setRows((p && p.inventory) || []); })
      .catch(function (err) { setError(err.message); });
  }, [session.eventId, session.stallId]);

  useEffect(function () { load(); }, [load]);

  var adjust = function (inv, delta) {
    setError("");
    vendorPortalApi.adjustStock({
      inventory_id: inv.id,
      adjustment_type: "MANUAL",
      quantity: delta,
      notes: "Vendor portal adjustment"
    })
      .then(function () { setSuccess("Stock updated"); load(); })
      .catch(function (err) { setError(err.message); });
  };

  return (
    <VendorPortalLayout>
      <h2 style={{ margin: "0 0 12px", fontSize: 16 }}>Inventory</h2>
      {error ? <div className="vp-err">{error}</div> : null}
      {success ? <div className="vp-card" style={{ background: "#ecfdf5", color: "#047857" }}>{success}</div> : null}
      <div className="vp-card stf-card--flush">
        {rows.length === 0 ? (
          <p style={{ margin: 0, color: "#64748b" }}>No stock rows. Ask ParkAdda staff to load opening stock.</p>
        ) : (
          <table className="vp-table">
            <thead>
              <tr><th>Item</th><th>On hand</th><th></th></tr>
            </thead>
            <tbody>
              {rows.map(function (r) {
                return (
                  <tr key={r.id}>
                    <td>{r.item_name || r.vendor_item_name}</td>
                    <td>{r.current_stock}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <button type="button" className="vp-btn vp-btn--ghost" style={{ width: "auto", padding: "4px 8px", marginRight: 4 }} onClick={function () { adjust(r, -1); }}>−1</button>
                      <button type="button" className="vp-btn vp-btn--ghost" style={{ width: "auto", padding: "4px 8px" }} onClick={function () { adjust(r, 1); }}>+1</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </VendorPortalLayout>
  );
};

export default VendorPortalStockPage;
